module.exports = __webpack_public_path__ + "static/media/Webarch.c0daffca.jfif";